import { useEffect, useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import useScrollReveal from '@/hooks/useScrollReveal';

const compliancePoints = [
  { id: 'c-1', icon: 'ri-government-line', title: '以公开来源为基准', desc: '核验结论优先对照可回溯的公开通报与澄清声明，不采信无法溯源的二手转述。' },
  { id: 'c-2', icon: 'ri-user-unfollow-line', title: '不涉及个人隐私', desc: '归档只保留与事件本身相关的素材，不对当事人隐私信息做任何整理或传播。' },
  { id: 'c-3', icon: 'ri-edit-2-line', title: '存疑内容会被更正', desc: '被证实为不实的条目会更新状态或移出归档，并在时间线中留下更正说明。' },
  { id: 'c-4', icon: 'ri-scales-3-line', title: '理性浏览、不跟风', desc: '希望访问者先看证据再下判断，避免仅凭一段剪辑过的画面就给事件定性。' },
];

export default function ComplianceSection() {
  const [notified, setNotified] = useState(false);
  const { ref, visible } = useScrollReveal();

  useEffect(() => {
    if (!notified) {
      return undefined;
    }
    const timer = window.setTimeout(() => setNotified(false), 3200);
    return () => window.clearTimeout(timer);
  }, [notified]);

  return (
    <section id="submit" className="w-full bg-background-50 py-16 md:py-24 scroll-mt-24">
      <div ref={ref} className={`w-full px-4 md:px-8 nh-reveal ${visible ? 'nh-in' : ''}`}>
        <SectionHeading
          kicker="合规与免责"
          title="归档是为了澄清，不是为了曝光"
          desc="我们相信有图有真相，但也相信真相需要被理性对待。以下四条是这个站点一直坚持的原则。"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {compliancePoints.map((point) => (
            <div key={point.id} className="rounded-lg bg-background-100 border border-background-200 p-6">
              <span className="flex w-12 h-12 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${point.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">{point.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{point.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-lg bg-secondary-100 border border-secondary-200 px-6 md:px-8 py-7 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-5">
          <div className="max-w-xl text-center lg:text-left">
            <h3 className="font-heading text-lg md:text-xl font-bold text-secondary-900">有素材想补充，或需要提交更正说明？</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              请连同素材出处与拍摄时间一并说明，核验组会按顺序处理。涉及权益争议的说明会优先查看。
            </p>
          </div>
          <div className="flex flex-col items-center lg:items-end gap-3">
            <button
              type="button"
              onClick={() => setNotified(true)}
              className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-upload-2-line"></i>
              提交线索与更正
            </button>
            {notified && (
              <span className="inline-flex items-center gap-2 text-xs text-secondary-900 nh-fade-in">
                <i className="ri-checkbox-circle-line text-primary-600"></i>
                已记录你的提交，核验组会按顺序处理（演示提示）
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}